import { render, staticRenderFns } from "./BannerToast.vue?vue&type=template&id=a284f0b0"
import script from "./BannerToast.vue?vue&type=script&lang=ts"
export * from "./BannerToast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports